import DynamicFieldGrid from "./DynamicFieldGrid";

export default function DynamicAccordionBlock({ title, open, onToggle, fields, values, onChange, errors, extra, configOptions, readOnly, showRequired }) {
  return (
    <div className="accordion">
      <button type="button" className="accordion__toggle" onClick={onToggle}>
        <span className="accordion__title">{title}</span>
        <span className="accordion__sign">{open ? "−" : "+"}</span>
      </button>
      {open && (
        <div className="accordion__body">
          <DynamicFieldGrid fields={fields} values={values} onChange={onChange} errors={errors} configOptions={configOptions} readOnly={readOnly} showRequired={showRequired} />
          {extra}
        </div>
      )}
    </div>
  );
}
